import React from 'react';
import EmptyBox from './assets/empty-box.png';

function EmptyBoxIcon() {
  return <img src={EmptyBox.src} width="164" height="130" alt="" />;
}

export default EmptyBoxIcon;
